import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AnyId, Brand } from '@workspace/data-types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aura-clipboard',
  templateUrl: './clipboard.component.html',
  imports: [CommonModule, MatIconModule, MatButtonModule],
})
export class AuraClipboardComponent {
  textToCopy = input.required<string | Brand<AnyId, string>>();
  copied = signal(false);

  copy(): void {
    if (!this.textToCopy) return;

    void navigator.clipboard.writeText(this.textToCopy().toString()).then(() => {
      this.copied.set(true);
      setTimeout(() => this.copied.set(false), 2000);
    });
  }
}
